export enum QuestionnaireType {
  CUSTOMER_ABOUT_HIMSELF = 1,
  CUSTOMER_ABOUT_THERAPIST = 2,
  THERAPIST_ABOUT_CUSTOMER = 3,
  THERAPIST_ABOUT_THERAPYSIDE = 4,
  CUSTOMER_ABOUT_DELETE = 5,
}

export enum QuestionnaireTrigger {
  TRIGGER_CUSTOMER_ABOUT_HIMSELF = 3,
  TRIGGER_REASSIGN_REQUEST = 11,
}

export enum AnswerType {
  RATING = "rating",
  LONG_TEXT = "long_text",
  YES_NO = "yes_no",
  STATEMENT = "statement",
  MULTIPLE_CHOICE = "multiple_choice",
  DATE = "date",
  PICTURE_CHOICE = "picture_choice",
}

export interface QuestionnaireSummary {
  createdAt: Date;
  id: string;
  isCompleted: boolean;
  questionnaireId: string;
  renderUrl: string;
  type: QuestionnaireType;
  updatedAt: Date | null;
  visible: boolean;
}

interface trigger {
  triggerId: number;
}

export interface Questionnaire {
  id: string;
  createdAt?: Date;
  name: string;
  renderUrl: string;
  type: QuestionnaireType;
  triggersId: trigger[];
  isVisible: boolean;
}

export interface Answers {
  questionType: AnswerType;
  question: string;
  answer: string | number | string[];
  order: number;
}

export interface QuestionnaireAnswers {
  uuid: string;
  userQuestionnaireUuid: string;
  answers: Answers[];
}
